// src/components/ServicePageHelmet.jsx

import React from "react";
import { Helmet } from "react-helmet";

import { API_URL, REACT_APP_SITE_KEY } from "../../config/app-config";

const ServicePageHelmet = ({ eventDetails, serviceDetails, serviceList, userDetails }) => {
  const eventData      = eventDetails  || {};
  const activeService  = serviceDetails || serviceList?.[0] || {};
  const user           = userDetails   || {};

  // 1. Business name
  const businessBrandName =
    eventData.businessName || user.userName || "Yuukke";

  // 2. Title
  const serviceTitle =
    activeService.serviceName || eventData.serviceName || "Service Booking";
  const pageTitle = `${serviceTitle} | ${businessBrandName}`;

  // 3. Description
  const rawDescription =
    activeService.description ||
    eventData.description ||
    "Book an appointment online.";
  const cleanDescription = rawDescription
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .substring(0, 160);

  // 4. Keywords
  const featureList = activeService.features || "";
  const keywords = [
    businessBrandName,
    serviceTitle,
    user.userName,
    featureList,
    "Appointment",
    "Booking",
  ]
    .filter(Boolean)
    .join(", ");

  // 5. Canonical URL
  const dbSlug = eventData.slug || "";
  const canonicalUrl = dbSlug
    ? `https://yuukke.com/yuukke-service/${dbSlug}`
    : window.location.href.split("?")[0];

  // 6. Image
  const seoImage = activeService.img
    ? `${API_URL}auth/image/${activeService.img}`
    : eventData.businessLogo
      ? `${API_URL}auth/image/${eventData.businessLogo}`
      : user.userId
        ? `${API_URL}api/getUserPhoto/${user.userId}/name`
        : "https://yuukke.com/images/logo.png";

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description"  content={cleanDescription} />
      <meta name="keywords"     content={keywords} />
      <link rel="canonical"     href={canonicalUrl} />

      <meta property="og:type"        content="website" />
      <meta property="og:site_name"   content="Yuukke" />
      <meta property="og:title"       content={pageTitle} />
      <meta property="og:description" content={cleanDescription} />
      <meta property="og:image"       content={seoImage} />
      <meta property="og:url"         content={canonicalUrl} />

      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={pageTitle} />
      <meta name="twitter:description" content={cleanDescription} />
      <meta name="twitter:image"       content={seoImage} />
    </Helmet>
  );
};

export default ServicePageHelmet;